import {Box, Grid, Typography} from "@mui/material";

export const TempoLiberoNew = ({section, direction}) => {

    return (
        <Box sx={{p:0.5 , border:'1px solid #fff', borderRadius:'5px', marginBottom:'5%', backgroundColor:'#d1112c', color:'#fff'}}>
            <Grid container direction={{xs:'column', md:direction}} spacing={{xs:1, md:4}} alignItems={'center'} justifyContent={'center'}>
                {section.image && <Grid item xs={12} md={4} sx={{flexGrow: 1, display:'flex'}}>
                    <img style={{width: '100%', objectFit:'cover', height:'100%'}}
                         src={section.image}/>
                </Grid>}
                <Grid item xs={12} md={8} >
                    <Box sx={{py:0.5, borderLeft:'3px solid #fff'}}>
                        <Typography variant={'h6'} color={'#fff'} fontWeight={'bold'} textTransform={'uppercase'} style={{marginLeft:'1%'}}>
                            {section.title}
                        </Typography>
                    </Box>
                    <Typography variant={'body1'} fontWeight={'normal'} fontFamily={'Arial'} mt={2}>
                        {section.description}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}